import { ISettingsService } from "../../../typings/typings";
import { RootState, getLeagueResults, entryAvailable, LoadLeagueResultsOnceAction, distinct } from "@play/state";
import { Store } from "@ngrx/store";
import { IApiMatchResult } from "ng-league";
import { filter, first } from "rxjs/operators";

export class LeagueMatchResource {
    public static $inject = ["SettingsService", "$resource", "store", "$q"];
    constructor(
        private SettingsService: ISettingsService,
        private $resource,
        private store: Store<RootState>,
        private $q: angular.IQService
    ) {}

    public getMatchResults(leagueId: number): Promise<IApiMatchResult[]> {
        const deferred = this.$q.defer();

        this.store.dispatch(new LoadLeagueResultsOnceAction(leagueId));

        this.store
            .select(getLeagueResults(leagueId))
            .pipe(
                filter(entryAvailable),
                distinct(entry => entry.entry),
                first()
            )
            .subscribe(x => deferred.resolve(x), x => deferred.reject(x));

        return deferred.promise as any;
    }

    public getUpcomingMatch(leagueId, userId, limit) {
        if (typeof limit.open === "undefined" || limit.challenge === "undefined") {
            return this.$resource(
                this.SettingsService.eslapi_host + "/users/:userId/matches?leagueIds=:leagueId&limit=1&state=open,challenge,protest"
            ).query({
                userId: userId,
                leagueId: leagueId,
            }).$promise;
        } else {
            return this.$resource(
                this.SettingsService.eslapi_host +
                    "/users/:userId/matches?leagueIds=:leagueId&limit.open=:limitOpen&limit.challenge=:limitChallenge&state=open,challenge,protest"
            ).query({
                userId: userId,
                leagueId: leagueId,
                limitOpen: limit.open,
                limitChallenge: limit.challenge,
                limitProtest: limit.protest,
            }).$promise;
        }
    }

    public getRecentResults(leagueId, userId, limit) {
        if (typeof limit.closed === "undefined") {
            return this.$resource(
                this.SettingsService.eslapi_host + "/users/:userId/matches?leagueIds=:leagueId&limit=:limit&state=closed,protest"
            ).query({
                userId: userId,
                leagueId: leagueId,
                limit: limit,
            }).$promise;
        } else {
            return this.$resource(
                this.SettingsService.eslapi_host +
                    "/users/:userId/matches?leagueIds=:leagueId&limit.closed=:limitClosed&state=closed,protest"
            ).query({
                userId: userId,
                leagueId: leagueId,
                limitClosed: limit.closed,
            }).$promise;
        }
    }

    public getCurrentResult(matchId) {
        return this.$resource(this.SettingsService.eslapi_host + "/matches/:matchId/result").get({
            matchId: matchId,
        }).$promise;
    }

    public getCurrentSetup(matchId) {
        return this.$resource(this.SettingsService.eslapi_host + "/matches/:matchId/setup").get({
            matchId: matchId,
        }).$promise;
    }
}
